export function getMonthlyPrice(vehicle) {
    const results = vehicle?.finance?.FinanceProductResults;
    
    if (!Array.isArray(results) || !results.length) {
        return null;
    }

    const cheapest = results.reduce((lowest, product) => {
        const payment = product?.Quote?.AllInclusiveRegularPayment;
        if (typeof payment !== 'number') return lowest;

        if (!lowest) return product;

        return payment < lowest.Quote.AllInclusiveRegularPayment
            ? product
            : lowest;
    }, null);

    return cheapest?.Quote?.AllInclusiveRegularPayment ?? null;
}

export function updateMonthlyPrices(vehicles) {
    if (!Array.isArray(vehicles)) return;

    vehicles.forEach(vehicle => {
        const els = document.querySelectorAll(
            `[data-monthly-price][data-vehicle-id="${vehicle.id}"]`
        );

        if (!els.length) return;

        const monthly = getMonthlyPrice(vehicle);
        if (!monthly) return;

        els.forEach(el => {
            if (el.closest('.swiper-slide-duplicate')) return;
            if (!el.classList.contains('is-loading')) return;
            el.textContent = `£${Number(monthly).toFixed(0)}`;
            el.classList.remove('is-loading');
            el.classList.remove('has-error');
        });
    });
}